export const ATTACHED = 'attached';
export const DETACHED = 'detached';
export const FAILED = 'failed';